/** @format */

export const DEFAULT_SORT_VALUE = '0';

export const GTGT_FILTER_NAME = 'Guaranteed_To_Get_There';
export const GTGT_TITLE = 'Shipping Options';
export const GTGT_FILTER_VALUE_DSG_PL = 'Get it by 6/14';
export const GTGT_FILTER_VALUE_GG = 'Get it by 6/14';

export const PRICE_FILTER_ID = 'dickssportinggoodsofferprice';
export const CATEGORY_FILTER_ID = 'facetCatgroup';
export const FACET_STORE = 'facetStore';
export const BRAND_FILTER_ID = 'X_BRAND';
export const RATINGS_FILTER_ID = 'X_BazaarVoice_ratings_DSG';
export const SIZE_FILTER_ID = '299';
export const KIDS_SHOES_SIZE = '5214';
export const WOMENS_SHOES_SIZE = '5213';
export const MENS_SHOES_SIZE = '5212';
export const DEFAULT_PAGE_SIZE = 48;
export const PERFORMANCE_PAGE_SIZE = 24;
export const PAGE_SIZE_OPTIONS = [48, 96, 144];
export const PERFORMANCE_PAGE_SIZE_OPTIONS = [PERFORMANCE_PAGE_SIZE, ...PAGE_SIZE_OPTIONS];
export const DSG_MOBILE_BROWSE_PLA_ID = 14095;
export const DSG_DESKTOP_BROWSE_PLA_ID = 14085;
export const DSG_MOBILE_SEARCH_PLA_ID = 14090;
export const DSG_DESKTOP_SEARCH_PLA_ID = 14080;
